import type { SVGProps } from "react";

/** lucide has no TikTok/Threads glyph — inline, currentColor, same 24 grid. */
export function TikTokIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden focusable="false" {...props}>
      <path d="M16.5 2h-2.9v13.1a2.6 2.6 0 1 1-2.6-2.6c.2 0 .5 0 .7.1v-3a5.6 5.6 0 1 0 4.8 5.5V8.9a6.7 6.7 0 0 0 3.9 1.2V7.2a3.9 3.9 0 0 1-3.9-3.9V2Z" />
    </svg>
  );
}

export function ThreadsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden focusable="false" {...props}>
      <path d="M12.2 22h-.1c-3.1 0-5.5-1-7.1-3C3.5 17.2 2.8 14.8 2.8 12s.7-5.2 2.2-7C6.6 3 9 2 12.1 2h.1c2.4 0 4.4.6 5.9 1.8 1.4 1.1 2.4 2.7 3 4.7l-2 .6c-1-3.3-3.3-5-6.9-5h-.1c-2.4 0-4.2.7-5.4 2.2C5.5 7.7 5 9.6 5 12s.6 4.3 1.7 5.7c1.2 1.5 3 2.2 5.4 2.2h.1c2.2 0 3.6-.5 4.6-1.4.9-.8 1.3-1.8 1.3-2.8 0-1.1-.4-2-1.3-2.7-.3-.2-.6-.4-1-.6-.2 1.2-.6 2.2-1.2 2.9-.8 1-2 1.5-3.4 1.5-1.1 0-2.1-.3-2.8-.9a3 3 0 0 1-1.1-2.5c0-1.9 1.6-3.4 4.4-3.4.7 0 1.4 0 2 .1 0-.4-.2-.9-.4-1.2-.4-.5-1-.8-1.8-.8-1 0-1.7.3-2.2 1l-1.7-1.2c.9-1.2 2.2-1.8 3.9-1.8 1.4 0 2.6.5 3.4 1.5.6.8 1 1.8 1.1 3 .5.2 1 .5 1.4.8 1.4 1.1 2.1 2.6 2.1 4.4 0 1.7-.7 3.2-2 4.4-1.4 1.2-3.4 1.8-6.1 1.8Zm-.5-9.6c-1.7 0-2.4.7-2.4 1.4 0 .4.2.7.4.9.3.3.8.4 1.4.4.8 0 1.4-.3 1.8-.8.4-.5.6-1.2.7-2.1-.6-.1-1.2-.2-1.9-.2Z" />
    </svg>
  );
}

export function WhatsAppIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden focusable="false" {...props}>
      <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7c.1.2 1.9 2.9 4.6 4 1.7.7 2.4.8 3.2.6.5-.1 1.5-.6 1.8-1.2.2-.6.2-1.1.1-1.2l-.5-.3Z" />
    </svg>
  );
}

export function FacebookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden focusable="false" {...props}>
      <path d="M13.5 22v-8.2h2.8l.4-3.2h-3.2V8.5c0-.9.3-1.6 1.6-1.6h1.7V4.1c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.4H7.3v3.2h2.8V22h3.4Z" />
    </svg>
  );
}

export function TelegramIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden focusable="false" {...props}>
      <path d="M21.6 3.2 2.9 10.4c-1.3.5-1.3 1.2-.2 1.6l4.8 1.5 1.8 5.6c.2.6.4.8.8.8s.6-.2.9-.5l2.3-2.2 4.8 3.5c.9.5 1.5.2 1.7-.8l3.1-14.7c.3-1.3-.5-1.9-1.3-1.5ZM9.7 14l-.4 4-1.4-4.5L18.6 7 9.7 14Z" />
    </svg>
  );
}

export function XIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden focusable="false" {...props}>
      <path d="M17.8 3h3.1l-6.8 7.7 8 10.3h-6.2l-4.9-6.3L5.4 21H2.3l7.2-8.3L1.8 3h6.4l4.4 5.8L17.8 3Zm-1.1 16.2h1.7L7.4 4.7H5.6l11.1 14.5Z" />
    </svg>
  );
}
